import cn from "classnames";
import { IH3Props } from "./H3.props";
import styles from "./H3.module.scss";

const H3 = ({ className, ...props }: IH3Props): JSX.Element => {
	return (
		<h3 className={cn(styles.header, className)} {...props}>
			{props.children}
		</h3>
	);
};

export default H3;
